import { render, staticRenderFns } from "./icon-button.vue?vue&type=template&id=fa4f5c28&scoped=true"
import script from "./icon-button.vue?vue&type=script&lang=ts"
export * from "./icon-button.vue?vue&type=script&lang=ts"
import style0 from "./icon-button.vue?vue&type=style&index=0&id=fa4f5c28&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4f5c28",
  null
  
)

export default component.exports